var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"back":"product","title":_vm.$t('titles.changeColor')}},[_c('color-picker',{attrs:{"colors":_vm.colors,"selected-color":_vm.selectedColor},on:{"selectColor":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }